import React from "react";
import { isImageCloudinary } from "../../layout/Layout";
import { CheckSelectorWrapper, TemplateWrapper } from "../PreviewArea.styled";
import { IconCheck, IconCheckEmpty } from "../../../../../../Components/Icons";
import { Button } from "../../../../../../Components/Button";
import useContainerWidth from "../../../../../../hooks/useContainerWidth";

export const ImageOrientationPreview = ({
  orientation,
  templateKey,
  dimensions,
  templateInputProps,
  selectedTemplates,
  handleTemplateClick,
  previewInputProps,
  TemplateComponent
}) => {
  const { aspectRatio } = dimensions["DefaultImage"][orientation] || dimensions.default;

  const isTemplateSelected = selectedTemplates.some(
    (template) => template.templateKey === templateKey
  );

  const imageUsed = templateInputProps[templateKey]?.backgroundImage;
  const isCropped = templateInputProps[templateKey]?.isCropped;

  const isCloudinaryImage = isImageCloudinary(imageUsed);
  const { containerRef, containerWidth } = useContainerWidth();

  return (
    <TemplateWrapper
      ref={containerRef}
      data-action="select"
      data-templatekey={templateKey}
      data-templateorientation={orientation}
      data-ismultiorientation={true}
      isTemplateSelected={isTemplateSelected}
      onClick={handleTemplateClick}
      aspectRatio={aspectRatio}
    >
      <CheckSelectorWrapper>
        {isTemplateSelected ? <IconCheck /> : <IconCheckEmpty />}
      </CheckSelectorWrapper>

      {isCloudinaryImage ? (
        <Button
          text={isCropped ? "Reset crop" : "Auto crop"}
          variant="tertiary"
          size="small"
          style={{ position: "absolute", top: "10px", left: "10px", zIndex: 3 }}
          data-action="autocrop"
          data-templatekey={templateKey}
          data-templateorientation={orientation}
          data-storevalue={imageUsed}
          data-storekey="backgroundImage"
          onClick={handleTemplateClick}
        />
      ) : null}

      <TemplateComponent
        {...previewInputProps}
        backgroundImage={imageUsed}
        width={containerWidth}
        isNewCampaign
      />
    </TemplateWrapper>
  );
};
